import React, { useEffect, useRef } from 'react';

const AcceptedModal = ({ open, onClose, isSpecial, email, setEmail, onSubmit }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };
    if (open) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="celebration-popup">
      <div className="celebration-content" ref={modalRef}>
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>{isSpecial ? 'You found it!' : 'Welcome!'}</h2>
        <p>
          {isSpecial
            ? 'You found the great one! Submit your email for 6+ months of free usage.'
            : 'Please submit your email below.'}
        </p>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(email, isSpecial); }}>
          <input
            type="email"
            placeholder="Enter your email"
            className="footer-input"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <button type="submit" className="footer-button">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default AcceptedModal;
